import { connect } from 'react-redux';
import {
    saveTimeSheetBegin,
    setSelectedTimeSheetDate,
    AddTimeSheetCommentBegin,
    getTimeSheetCommentListBegin,
    getAppointmentsBySelectedDateBegin,
} from '../../../store/actions/timeSheet.actions';
import {
    getTimeSheetStatus,
    getTimeSheetEndDate,
    getExpenseCategories,
    getTimeSheetStartDate,
    getTimeSheetCategories,
    getLocationFormDetails,
    getTimeSheetAppointments,
    getTimeSheetSelectedDate,
    getTimeSheetAppointmentsLoadingStatus,
    getTimeSheetCategoriesLoadingStatus,
    getTimeSheetCommentList,
    getAddTimeSheetCommentLoader,
    getTimeSheetId,
    getTimeSheetDetailLoadingStatus,
    getTimesheetPackLoading,
    getTimeSheetType,
} from '../../../store/selectors/timeSheet.selectors';
import EditTimeSheet from './EditTimeSheet';

const mapStateToProps = (state: any) => {
    const timeSheetCategories = getTimeSheetCategories(state);
    const timeSheetAppointments = getTimeSheetAppointments(state);
    const selectedTimeSheetDate = getTimeSheetSelectedDate(state);
    const isTimeSheetCategoriesLoading = getTimeSheetCategoriesLoadingStatus(state);
    const isTimeSheetAppointmentsLoading = getTimeSheetAppointmentsLoadingStatus(state);
    const startDate = getTimeSheetStartDate(state);
    const endDate = getTimeSheetEndDate(state);
    const timeSheetStatus = getTimeSheetStatus(state);
    const expenseCategories = getExpenseCategories(state);
    const isExpenseCategoriesLoading = getTimeSheetCategoriesLoadingStatus(state);
    const editForm = getLocationFormDetails(state);
    const loading = getAddTimeSheetCommentLoader(state);
    const timeSheetCommentList = getTimeSheetCommentList(state);
    const timesheetId = getTimeSheetId(state);
    const isTimeSheetLoading = getTimeSheetDetailLoadingStatus(state);
    const isInspectorPackLoading = getTimesheetPackLoading(state);
    const timesheetTypes = getTimeSheetType(state);

    return {
        loading,
        endDate,
        editForm,
        startDate,
        timesheetId,
        timesheetTypes,
        timeSheetStatus,
        expenseCategories,
        isTimeSheetLoading,
        timeSheetCategories,
        timeSheetCommentList,
        selectedTimeSheetDate,
        timeSheetAppointments,
        isInspectorPackLoading,
        isExpenseCategoriesLoading,
        isTimeSheetCategoriesLoading,
        isTimeSheetAppointmentsLoading,
    };
};

const mapDispatchToProps = {
    setSelectedTimeSheetDate,
    saveTimeSheet: saveTimeSheetBegin,
    addTimeSheetComment: AddTimeSheetCommentBegin,
    getTimesheetComment: getTimeSheetCommentListBegin,
    getAppointmentsBySelectedDate: getAppointmentsBySelectedDateBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTimeSheet);
